import React from "react";
import { withShoppingCartContainer } from "../../containers/gamification2026";
import { matchPath } from "react-router-dom";
import { t } from "../../../i18n";

// Ordered step definitions — index order determines "completed" logic.
// The address step is always present; digital-only carts insert an extra
// contacts step between the address and the checkout summary.
const getSteps = (allDigitalCards) => {
  const steps = [
    { to: "/cart",         exact: true, label: () => t("gamification2026.cart.step-1") },
    { to: "/cart/address", exact: true, label: () => t("gamification2026.cart.step-2") },
  ];

  if (allDigitalCards) {
    steps.push({
      to: "/cart/contacts",
      exact: true,
      label: () => t("gamification2026.cart.step-2-contacts"),
    });
  }

  steps.push({ to: "/cart/checkout", exact: false, label: () => t("gamification2026.cart.step-3") });

  return steps;
};

const CartStep = ({ isActive, isCompleted, onClick, className, children }) => {
  if (isCompleted) {
    return (
      <button
        type="button"
        className={["px-0", className].join(" ")}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }
  return <div className={["px-0", className].join(" ")}>{children}</div>;
};

const CartNavigation = ({ history, allDigitalCards }) => {
  const steps = getSteps(allDigitalCards);
  const currentStepIndex = steps.findIndex(({ to, exact }) =>
    matchPath(window.location.pathname, { path: to, exact })
  );

  return (
    <nav className="cart-navigation">
      {steps.map((step, index) => {
        const isActive    = index === currentStepIndex;
        const isCompleted = index < currentStepIndex;
        const isLast      = index === steps.length - 1;

        let itemClass = "cart-navigation-item";
        if (isActive)    itemClass = "cart-navigation-item-active";
        if (isCompleted) itemClass = "cart-navigation-item-completed";

        return (
          <CartStep
            key={step.to}
            isActive={isActive}
            isCompleted={isCompleted}
            className={itemClass}
            onClick={isCompleted ? () => history.push(step.to) : undefined}
          >
            <span>{step.label()}</span>
            {!isLast && <i className="px-1 fas fa-chevron-right" />}
          </CartStep>
        );
      })}
    </nav>
  );
};

export default withShoppingCartContainer(CartNavigation);
